export default __webpack_public_path__ + "static/media/icon_8.31c7252b.png";